import { useEffect, useState } from "react";
import clinicAPI from "../../../services/clinicApi";
import SettingsPortalBrandingPanel from "../AdminSettings/SettingsPortalBrandingPanel";
import { HubFormCard, HubSheet } from "../AdminPortal/HubPwa";
import aa from "../AdminPortal/adminApp.module.css";
import { Button, Field, Input, Textarea, useToast } from "../../ui";

export default function AdminClubEditSheet({ open, tenant, onClose, onUpdated }) {
  const toast = useToast();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [saving, setSaving] = useState(false);
  const [branding, setBranding] = useState(null);

  useEffect(() => {
    if (!open || !tenant) return;
    setName(tenant.name || "");
    setDescription(tenant.portal_description || "");
    setPhone(tenant.phone || "");
    setAddress(tenant.address || "");
    setBranding(tenant);
  }, [open, tenant]);

  const saveInfo = async () => {
    if (!name.trim() || name.trim().length < 2) {
      toast.error("Название клуба слишком короткое");
      return;
    }
    setSaving(true);
    try {
      const res = await clinicAPI.updateTenantSettings({
        name: name.trim(),
        portal_description: description.trim(),
        phone: phone.trim(),
        address: address.trim(),
      });
      const next = res.tenant;
      setBranding(next);
      onUpdated?.(next);
      toast.success("Сохранено");
      onClose?.();
    } catch (err) {
      toast.error(err.response?.data?.error || "Не удалось сохранить");
    } finally {
      setSaving(false);
    }
  };

  const handleBrandingUpdated = (next) => {
    setBranding(next);
    onUpdated?.(next);
  };

  return (
    <HubSheet
      open={open}
      onClose={onClose}
      title="Редактировать клуб"
      subtitle="Как видят клиенты на вкладке «Клуб»"
      bodyClassName={aa.adminClubEditBody}
    >
      <HubFormCard title="О клубе">
        <Field label="Название">
          <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Название клуба"
          />
        </Field>
        <Field label="Описание">
          <Textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Кратко о клубе, направлениях и атмосфере"
            rows={4}
          />
        </Field>
        <Field label="Телефон">
          <Input
            type="tel"
            inputMode="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="+7 …"
          />
        </Field>
        <Field label="Адрес">
          <Input
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            placeholder="Город, улица, дом"
          />
        </Field>
        <Button type="button" onClick={saveInfo} disabled={saving}>
          {saving ? "Сохранение…" : "Сохранить описание"}
        </Button>
      </HubFormCard>

      {branding ? (
        <SettingsPortalBrandingPanel
          compact
          accentColor={branding.portal_accent_color}
          coverUrl={branding.portal_cover_url}
          logoUrl={branding.logo_url}
          fontFamily={branding.portal_font_family}
          galleryUrls={branding.portal_gallery || []}
          onUpdated={handleBrandingUpdated}
        />
      ) : null}
    </HubSheet>
  );
}
